
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-members/[slug]",
      function () {
        return require("private-next-pages/team-members/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-members/[slug]"])
      });
    }
  